var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "watchPhoneNumber" }, [
    _vm.phoneAreaCode && _vm.phoneNumber
      ? _c("span", [_vm._v("+" + _vm._s(_vm.phoneAreaCode) + " ")])
      : _vm._e(),
    _c("span", { staticClass: "phoneNumber" }, [
      _vm._v(" " + _vm._s(_vm.phoneNumber) + " "),
    ]),
    !_vm.ifReal && _vm.phoneNumber
      ? _c("i", {
          staticClass: "pointer",
          class: _vm.loading ? "el-icon-loading" : "el-icon-view",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.onClick.apply(null, arguments)
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }